import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { TFunction } from "i18next";
import { PiChipSelectOption } from "../../../components/PiChipSelect";
import { NO_LOOKAT } from "../../../models/NoLookat";

const optionIcon = (icon: JSX.Element) => (
  <span className="flex-none flex items-center justify-center w-[28px] h-[28px] text-interaction-primary-faded">
    {icon}
  </span>
);

/** "No one": the actor stops looking. */
export const noLookatOption = (t: TFunction): PiChipSelectOption => ({
  id: NO_LOOKAT,
  label: String(t("chip_select.no_actor")),
  icon: optionIcon(<PersonOffOutlinedIcon sx={{ fontSize: 20 }} />),
});

/** "Keep current" (empty value): whatever the actor was looking at carries on. */
export const keepCurrentLookatOption = (t: TFunction): PiChipSelectOption => ({
  id: "",
  label: String(t("chip_select.keep_current")),
  icon: optionIcon(<RemoveOutlinedIcon sx={{ fontSize: 20 }} />),
});
